import { Controller } from 'stimulus'

const REPO_URL = 'https://github.com/Yuman-Brussels/yuman/'

export default class extends Controller {
  static targets = ['title', 'issues']

  connect() {
    fetch(this.data.get('url'), {
      credentials: 'same-origin',
      headers:     { 'Accept': 'application/json' },
    })
      .then(res => (res.ok ? res.json() : {}))
      .then(data => this.render(data || {}))
      .catch(() => {})
  }

  render(data) {
    if (this.hasTitleTarget && data.title) this.titleTarget.textContent = data.title

    const issues = Array.isArray(data.issues) ? data.issues : []
    if (issues.length === 0) return

    issues.forEach(issue => {
      const link = this.link(issue)
      if (link) this.issuesTarget.appendChild(link)
    })
    this.issuesTarget.hidden = false
  }

  link(issue) {
    if (!issue || !String(issue.url || '').startsWith(REPO_URL)) return null

    const link = document.createElement('a')
    link.className = `bo-announcement-source__issue${issue.state === 'closed' ? ' is-closed' : ''}`
    link.href      = issue.url
    link.target    = '_blank'
    link.rel       = 'noopener'
    link.textContent = `#${issue.number} ${issue.title || ''}`.trim()
    return link
  }
}
